import { STICKY_FOOTER_DESKTOP_TOGGLE_TRIGGER, STICKY_FOOTER_DESKTOP_VIEW, STICKY_FOOTER_MOBILE_VIEW } from './types';

export const triggerStickyFooterDesktopIsToggledGAEvent = (isExpanded, placement, config) => ({
  type: STICKY_FOOTER_DESKTOP_TOGGLE_TRIGGER,
  isExpanded,
  placement,
  config,
});

export const triggerStickyFooterDesktopIsViewed = (placement, config) => ({
  type: STICKY_FOOTER_DESKTOP_VIEW,
  placement,
  config,
});

export const triggerStickyFooterMobileIsViewed = () => ({
  type: STICKY_FOOTER_MOBILE_VIEW,
});
